<div class="esf-spinner flex-container-loading" *ngIf="loading">
  <div class="row">
    <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
  </div>
</div>
<ng-container *ngIf="!loading">
  <main class="esf-main-content esf-main-content--alternative -width-max -has-transition">
    <div class="esf-container esf-container--full-width" *ngIf="user">

      <button class="esf-button esf-button--simple" (click)="location.back()">
        <svg class="esf-icon esf-button__icon" width="12" height="12">
          <use xlink:href="#esf-icon-minimal-left"></use>
        </svg>
        <span class="esf-button__icon-text" i18n='Link text@@general.linkText.backToUserList'>Back to user list</span>
      </button>

      <h1 class="esf-heading esf-heading--page esf-action-heading">
        <div class="esf-action-heading__text">
          <span i18n='Main heading for the user profile component@@userOverviewComponent.heading.userProfile'>User profile</span>
        </div>
        <span class="esf-action-heading__actions">
          <span class="esf-action-heading__action">
            <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small"
                    (click)="userModalService.toggleModal(true)"
                    [disabled]="user.type === 'CallCenterAgent' && authenticatedUser.isClubAdmin"
                    [edsTooltip]="tooltipTranslations.i18nEdit">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-edit"></use>
              </svg>
            </button>
          </span>
          <span class="esf-action-heading__action">
            <span class="esf-tooltip esf-tooltip--top" i18n-data-tooltip='Tooltip@@general.tooltip.clubAssignment' data-tooltip="Club assignment">
              <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small"
                      (click)="resultsDataTable.setModalStatus(true);"
                      [disabled]="!(user.type === 'CallCenterAgent') || !(authenticatedUser.isAdmin)">
                <svg class="esf-icon" width="16" height="16">
                  <use xlink:href="#esf-icon-club"></use>
                </svg>
              </button>
            </span>
          </span>
        </span>
      </h1>

      <div class="grid-layout">
        <div class="grid-user">
          <div class="grid-container">
            <div class="flex-communication">
              <h5 class="heading heading--data" i18n='Section title@@userOverviewComponent.heading.userData'>User data</h5>
            </div>
            <div class="grid-wrapper grid-wrapper--extend flex-content">
              <div>
                <span class="first-name last-name">
                  <strong>{{ user.firstName }} {{ user.lastName }}</strong>
                </span>
              </div>
              <div>
                <span class="type">{{ getUserType(user.type) }}</span>
              </div>
              <div *ngIf="(user.type !== 'Admin') && (user.type !== 'CallCenterAgent') && (user.type !== 'CountryManager')">
                <span class="club">{{ user.clubs[0].name}}</span>
              </div>
              <div>
                <div class="esf-tags">
                  <span class="esf-tag" [ngClass]="user.status.class">{{ user.status.status }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid-space"></div>

        <div class="grid-authentication">
          <div class="grid-container">
            <div class="flex-communication">
              <h5 class="heading heading--data" i18n='Section title@@userOverviewComponent.heading.authenticationData'>Authentication data</h5>
            </div>
            <div class="grid-wrapper grid-wrapper--extend flex-communication">
              <div class="flex-content">
                <div>
                  <svg class="esf-icon" style="color: grey; opacity: 0.6; margin-right: 10px;" width="16" height="16">
                    <use xlink:href="#esf-icon-user-data"></use>
                  </svg>
                  <span class="username">{{ user.username }}</span>
                </div>
                <div>
                  <svg class="esf-icon" style="color: grey; opacity: 0.6; margin-right: 10px;" width="16" height="16">
                    <use xlink:href="#esf-icon-mail"></use>
                  </svg>
                  <span class="email">{{ user.email }}</span>
                </div>
                <div>
                  <svg class="esf-icon" style="color: grey; opacity: 0.6; margin-right: 10px;" width="16" height="16">
                    <use xlink:href="#esf-icon-clock"></use>
                  </svg>
                  <ng-container [ngSwitch]="user.tokenLifetime">
                    <span class="token" *ngSwitchCase="3600">1 {{ flTranslations.i18nHour }}</span>
                    <span class="token" *ngSwitchDefault>8 {{ flTranslations.i18nHours }}</span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
  <app-edit-user (userChange)="updateUser($event)" *ngIf="userModalService.modalOpened" [user]="user" [listOfClubs]="listOfAllClubs"></app-edit-user>
  <app-local-modal
                   [title]="i18nModalTitle"
                   [spinnerName]="'clubAssignmentSubmit'"
                   (submitClicked)="clubAssignment?.submitUserClubs()">
    <app-club-assignment (submitted)="resultsDataTable.setModalStatus(false)" [user]="user" [authenticatedUser]="authenticatedUser" [listOfAllClubs]="listOfAllClubs"></app-club-assignment>
  </app-local-modal>

</ng-container>
